var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-content",on:{"click":_vm.handleClick}},[_c('Head',{ref:"head"}),_c('section-1'),_c('section-2'),_c('section-3'),_c('section-4'),_c('section-5'),_c('section-6'),_c('section-7'),_c('bottom',{ref:"bottom"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }